import { STORAGE } from "./config.js";

// Thin, defensive wrapper over localStorage for the auth session. Every access
// is try/catch'd so a locked-down browser (private mode, disabled storage)
// degrades to "logged out" instead of throwing.

export function getToken() {
  try { return localStorage.getItem(STORAGE.token) || ""; } catch { return ""; }
}

export function getRefreshToken() {
  try { return localStorage.getItem(STORAGE.refresh) || ""; } catch { return ""; }
}

export function setTokens({ authenticationToken, refreshToken }) {
  try {
    if (authenticationToken) localStorage.setItem(STORAGE.token, authenticationToken);
    if (refreshToken) localStorage.setItem(STORAGE.refresh, refreshToken);
  } catch { /* storage disabled — session stays in memory only */ }
}

export function getProfile() {
  try {
    const raw = localStorage.getItem(STORAGE.profile);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

// The user id (profile._id) — used as the userId query param when refreshing.
export function getUserId() {
  const p = getProfile();
  return p?._id ?? null;
}

export function setProfile(profile) {
  try { localStorage.setItem(STORAGE.profile, JSON.stringify(profile)); } catch { /* storage disabled */ }
}

export function clearSession() {
  try {
    localStorage.removeItem(STORAGE.token);
    localStorage.removeItem(STORAGE.refresh);
    localStorage.removeItem(STORAGE.profile);
  } catch { /* storage disabled — nothing to clear */ }
}

export function isAuthed() {
  return !!getToken();
}
